/*
 * First-load skeleton — mirrors the ready card's shape (logo, eyebrow, title,
 * two sub lines, two chips, three rows) so the load→ready transition doesn't
 * jump. Announced politely + aria-busy for assistive tech.
 */
const LoadingView = () => (
  <div className="loading-wrap anim" role="status" aria-live="polite" aria-busy="true">
    <div className="sk sk-logo" aria-hidden="true" />
    <div className="card" aria-hidden="true">
      <div className="card-pad">
        <div className="eyebrow-row">
          <span className="sk sk-eyebrow" />
        </div>
        <div className="sk sk-title" />
        <div className="sk sk-sub" />
        <div className="sk sk-sub2" />
        <div className="sk-chips">
          <span className="sk sk-chip" />
          <span className="sk sk-chip" />
        </div>
        <div className="sk-rows">
          {[0, 1, 2].map((i) => (
            <div className="sk-row" key={i}>
              <span className="sk sk-badge" />
              <span className="sk-rowmeta">
                <span className="sk sk-a" />
                <span className="sk sk-b" />
              </span>
              <span className="sk sk-btn" />
            </div>
          ))}
        </div>
      </div>
    </div>
    <span className="visually-hidden">Loading your download…</span>
  </div>
);

export default LoadingView;
